import React from 'react';
import { withStyles, Dialog } from '@material-ui/core';
import { withSnackbar } from 'notistack';
import PriorityShipmentsGrid from './Grid/index';
import styles from '../ReturnShipments/styles';
import { compose } from 'recompose';
import { getDataWithQueryString } from '../../../../../api/componentAPIs';
import MESSAGES from '../../../../../appMessages';
import Events from '../../../../../utilities/EventEmitter';
import appConstants from '../../../../../appConstants';
import { observer, inject } from 'mobx-react';
import { sortBy } from 'lodash';
import { KPI_NAME } from '../constants';

@inject('DispatchStore')
@observer
class OpenPriorityShipments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      priorityShipments: [],
      kpiName: '',
      gridErrorMessage:  appConstants.GRID_STATUS.LOADING
    };
  }

  componentDidMount() {
    Events.on('OpenPriorityShipments', this.togglePriorityShipmentsModel);
  }

  componentWillUnmount() {
    Events.off('OpenPriorityShipments', this.togglePriorityShipmentsModel);
  }

  loadShipmentsByKpi = (kpiName = this.state.kpiName) => {
    if (!this.state.open) {
      return;
    }
    const terminalCode = this.props.userProfile.terminal.code;
    const getParameter = () => {
      if (kpiName === KPI_NAME.APT) {
        return `shipmentType=${kpiName}`;
      }
      return `priorityType=${kpiName}`;
    };
  
    getDataWithQueryString(
      'GetPriorityShipments',
      `terminalCode=${terminalCode}&${getParameter()}`
    ).then((res) => {
      if (res.status === 200) {
        this.setState({
          priorityShipments: this.getShipmentDriverInfo(res.data),
          gridErrorMessage: appConstants.GRID_STATUS.SUCCESS
        });
      } else {
        this.handleError();
      }
    });
  };

  getShipmentDriverInfo = (priorityShipments) => {
    return sortBy(
      priorityShipments.map((shipment) => {
        if (shipment.isRouteCompleted) {
          return shipment;
        } else {
          return {
            ...shipment,
            driverInfo: this.props.DispatchStore.getCurrentDriver(shipment.driverId) || null,
            terminalOffset: this.props.DispatchStore.terminalOffset
          };
        }
      }),
      'isCompleted'
    );
  };

  togglePriorityShipmentsModel = (kpiName) => {
    this.setState(
      (prevState) => ({
        open: !prevState.open,
        kpiName,
        priorityShipments: [],
        gridErrorMessage: appConstants.GRID_STATUS.LOADING
      }),
      () => {
        this.loadShipmentsByKpi(kpiName);
      }
    );
  };

  handleError = () => {
    this.props.enqueueSnackbar(MESSAGES.COMMON.LOADING_DATA, {
      variant: 'error'
    });
    this.setState({
      gridErrorMessage: appConstants.GRID_STATUS.ERROR,
      priorityShipments: []
    });
  };


  render() {
    const { classes } = this.props;
    const { theme } = this.props.userProfile || {};
    const { open, gridErrorMessage, kpiName, priorityShipments } = this.state;
    return (
      <>
        <Dialog
          aria-labelledby="priority-shipments"
          open={open}
          classes={{ paper: classes.dialog }}
          className={`${classes.dialogWrapper} ${theme}`}>
          <PriorityShipmentsGrid
            priorityShipments={priorityShipments}
            gridErrorMessage={gridErrorMessage}
            userProfile={this.props.userProfile}
            kpiName={kpiName}
            onCloseModel={this.togglePriorityShipmentsModel}
            glEventHub={this.props.glEventHub}
          />
        </Dialog>
      </>
    );
  }
}

export default compose(withSnackbar, withStyles(styles))(OpenPriorityShipments);
